import { APP_NAME } from 'configs/AppConfig';
import React from 'react'

export default function Footer() {
	return (
		<footer className="footer">
			<span> &copy; <span className="font-weight-semibold">ARBOR IDIOMAS LTDA CNPJ 53.448.066/0001-05 | Todos os direitos reservados</span></span>
		</footer>
	)
}

